"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NONCE_BYTES = exports.encrypt = exports.decrypt = void 0;
__exportStar(require("./getKeyMetadata"), exports);
var scryptEncryption_1 = require("./scryptEncryption");
Object.defineProperty(exports, "decrypt", { enumerable: true, get: function () { return scryptEncryption_1.decrypt; } });
Object.defineProperty(exports, "encrypt", { enumerable: true, get: function () { return scryptEncryption_1.encrypt; } });
Object.defineProperty(exports, "NONCE_BYTES", { enumerable: true, get: function () { return scryptEncryption_1.NONCE_BYTES; } });
